
  import { defineComponent, ref, watch } from 'vue';
  import InputText from './InputText.vue';
  
  export default defineComponent({
    props: {
      keyValue: {
        type: String,
        required: false
      },
      label: {
        type: String,
        required: true
      },
      required:{
      type: Boolean,
      required: false,
    },
      value: {
        type: String,
        required: true
      }
    },
    components: {
      InputText,
    },
    setup(props, { emit }) {
      const mode = ref('url'); // Mode default 'url'
      const imageUrl = ref<string | null>(props.value || null);
  
      // Fungsi untuk menangani perubahan file yang diupload
      const onFileChange = (event: Event) => {
        const fileInput = event.target as HTMLInputElement;
        if (fileInput.files && fileInput.files[0]) {
          const file = fileInput.files[0];
          const reader = new FileReader();
  
          reader.onload = (e: ProgressEvent<FileReader>) => {
            imageUrl.value = e.target?.result as string;
            emit('update', { key: props.keyValue || props.label, value: file }); // Emit file gambar yang diunggah ke parent
          };
  
          reader.readAsDataURL(file); // Membaca file gambar
        }
      };
  
      const updateValue = (params: { key: string; value: string }) => {
        imageUrl.value = params.value;
        emit('update', { key: props.keyValue || props.label, value: imageUrl.value });
      };
  
      // Watcher untuk mendeteksi perubahan pada mode dan mengupdate value
      watch(mode, (newMode) => {
        if (newMode === 'url') {
          imageUrl.value = props.value || null; // Reset ke URL jika mode 'url'
        } else if (newMode === 'upload') {
          imageUrl.value = null; // Reset ke null jika mode 'upload'
        }
      });
  
      return {
        mode,
        imageUrl,
        onFileChange,
        updateValue
      };
    }
  });
  